import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <a
        href="https://github.com/louiseahart/weather-app"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>
      , by Louise Hart
    </div>
  );
}
